import { CreateButton, List, useTable } from "@refinedev/antd";
import { CanAccess } from "@refinedev/core";
import { Button, Space, Table, Tag } from "antd";
import { useNavigate } from "react-router";

import { formatKurus, planLabel } from "../labels";
import type { OfficePlan } from "../types";

export const durationLabel = (months: number) => (months === 12 ? "Yıllık" : `${months} Ay`);

/**
 * /plans: plans on sale and off sale, by duration (permission `plans.manage`; product decision
 * 2026-10-09). A row opens the plan to change its price, "Popüler" or whether it is on sale.
 * Season plans (product decision 2026-10-11) are priced per week.
 */
export function PlansPage() {
  const navigate = useNavigate();
  const { tableProps } = useTable<OfficePlan>({
    resource: "plans",
    pagination: { mode: "off" },
    syncWithLocation: false,
  });

  return (
    <List
      title="Planlar"
      headerButtons={
        <CanAccess resource="plans" action="list">
          <Space>
            <Button onClick={() => navigate("/plans/seasons")}>Dönemler</Button>
            <Button onClick={() => navigate("/plans/pricing")}>Fiyatlandırma</Button>
            <CreateButton onClick={() => navigate("/plans/new")}>Yeni plan</CreateButton>
          </Space>
        </CanAccess>
      }
    >
      <Table
        {...tableProps}
        rowKey="id"
        pagination={false}
        scroll={{ x: "max-content" }}
        onRow={(plan) => ({
          onClick: () => navigate(`/plans/${plan.id}`),
          style: { cursor: "pointer" },
        })}
      >
        <Table.Column<OfficePlan> title="Plan" key="plan" render={(_, plan) => planLabel(plan)} />
        <Table.Column<OfficePlan>
          title="Fiyat"
          key="price"
          render={(_, plan) =>
            plan.season ? `${formatKurus(plan.priceKurus)} / hafta` : formatKurus(plan.priceKurus)
          }
        />
        <Table.Column<OfficePlan>
          title="Aylık"
          key="monthly"
          render={(_, plan) =>
            formatKurus(
              plan.season
                ? Math.round((plan.priceKurus * 52) / 12)
                : Math.round(plan.priceKurus / (plan.durationMonths ?? 1)),
            )
          }
        />
        <Table.Column<OfficePlan> title="Soru / ay" dataIndex="monthlyQuestions" />
        <Table.Column<OfficePlan>
          title="Durum"
          key="status"
          render={(_, plan) => (
            <Space size={4}>
              {plan.isActive ? <Tag color="green">Satışta</Tag> : <Tag>Satışta değil</Tag>}
              {plan.isFeatured ? <Tag color="blue">Popüler</Tag> : null}
            </Space>
          )}
        />
        <Table.Column<OfficePlan> title="Aktif abone" dataIndex="activeSubscriptions" />
      </Table>
    </List>
  );
}
